import ControllerChipIcon from './component'

export default ControllerChipIcon
